module.exports = __webpack_public_path__ + "img/tributario.2c4a5aba.svg";